import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import LoadingOverlay from 'react-loading-overlay';
import { useSelector } from 'react-redux';

import Layout from '../Layout/index';
import MainWrapper from './MainWrapper';
import LogIn from '../LogIn/index';
import Restaurants from '../Restaurants/index';
import Platforms from '../Platforms/index';
import { AuthProvider } from './authContext';

// const Pages = () => (
//   <Switch>
//     <Route path="/pages/one" component={ExamplePageOne} />
//     <Route path="/pages/two" component={ExamplePageTwo} />
//   </Switch>
// );

const privateRoutes = () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <Route exact path="/restaurants" component={Restaurants} />
      <Route exact path="/platforms" component={Platforms} />
      <Route exact path="/" component={Restaurants} />
    </div>
  </div>
);

const publicRouters = () => (
  <>
    <Route path="/login" component={LogIn} />
    <Route path="/" component={LogIn} />
  </>
)

const Router = () => {
  const [authState, setAuthState] = useState(false);
  const spinner = useSelector(state => state.app.spinner);
  const text = useSelector(state => state.app.text);

  useEffect(() => {
    const auth = localStorage.getItem('auth');
    setAuthState(auth);
  }, []);

  const changeAuthState = () => {
    const auth = localStorage.getItem('auth');
    setAuthState(auth);
  }

  return (
    <MainWrapper>
      <AuthProvider value={changeAuthState}>
        <LoadingOverlay
          active={spinner}
          spinner
          text={text}
          >
          <main>
            <Switch>
              {
                !authState ?
                <Route path="/" component={publicRouters} /> :
                <Route path="/" component={privateRoutes} /> 
              }
            </Switch>
          </main>
        </LoadingOverlay>
      </AuthProvider>
      
    </MainWrapper>
  );
};

export default Router;
